import { FC } from "react";
import { ChatUserListProps } from "./types";
import { useGeneralStore, usePopupStore, useThemeStore } from "../../../stores";
import { Column, Row, ScrollRow } from "../../../components/containers";
import StatusPicture from "../../../components/status-picture";
import { AlignItems, Wrap } from "../../../components/containers/types";
import { Text } from "../../../components/typography";
import { UserProps } from "../../admin-panel/users/types";
import { UserProfilePopup } from "../../admin-panel/users/user";

const ChatUserList: FC<ChatUserListProps> = ({ isMobile, isSidePanel }) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const users = useGeneralStore((s) => s.users);

  const Container = isMobile
    ? (props: { children: React.ReactNode }): React.JSX.Element => (
        <Row style={{ width: "100%" }} gap={20} flexWrap={Wrap.Wrap}>
          {props.children}
        </Row>
      )
    : (props: { children: React.ReactNode }): React.JSX.Element => (
        <ScrollRow style={{ width: "100%" }} height={55} gap={20}>
          {props.children}
        </ScrollRow>
      );

  const onClick = (user: UserProps): void => {
    setPopupBody(<UserProfilePopup {...user} />);
  };

  return (
    <Column
      gap={isMobile ? 10 : 0}
      alignItems={AlignItems.Start}
      style={{ width: "100%" }}
    >
      <Text color={isSidePanel ? theme.textOnOverlay : theme.textOnBg}>
        اعضای گروه :
      </Text>

      <Container>
        {users.map((user) => (
          <StatusPicture
            key={user._id.$oid}
            src={user.pic}
            type={"small"}
            status={user.status}
            onClick={() => onClick(user)}
          />
        ))}
      </Container>
    </Column>
  );
};

export default ChatUserList;
